import { zodResolver } from '@hookform/resolvers/zod'
import { Box, Button, Stack } from '@mui/material'
import { useMutation } from '@tanstack/react-query'
import { observer } from 'mobx-react'
import React from 'react'
import { useForm } from 'react-hook-form'
import z from 'zod'
import CustomAccordion from '../../../../../components/customElements/RequestDataAccordions/utils/CustomAccordion'
import { useInvalidateQueries } from '../../../../../hooks/useInvalidateQueries'
import { startInstallation } from '../../../../../services/ApiService'
import { validateEquipmentId } from '../../../../Service/components/NewDrawers/consts/searchDrawer.consts'
import FormInput from '../../../../SingleRequestPage/components/SingleRequestDrawer/elements/FormInput'
import { RequestType } from '../../../../SingleRequestPage/types/Request.type'
import { newRequestDrawerStore } from '../../../stores/NewRequestDrawerStore'

const startInstallationSchema = z.object({
  equipmentId: z.string().refine((val) => !!val && validateEquipmentId(val), {
    message: 'Неверный формат id оборудования',
  }),
})

type StartInstallationForm = z.infer<typeof startInstallationSchema>

interface StartInstallationAccProps {
  request: RequestType
}

const StartInstallationAcc: React.FC<StartInstallationAccProps> = ({
  request,
}) => {
  const invalidate = useInvalidateQueries()
  const {
    control,
    formState: { isValid },
    watch,
  } = useForm<StartInstallationForm>({
    mode: 'onChange',
    defaultValues: {
      equipmentId: '',
    },
    resolver: zodResolver(startInstallationSchema),
  })

  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['start-installation'],
    mutationFn: () =>
      startInstallation({
        orderId: request.id,
        equipmentId: watch('equipmentId'),
      }),
    onSuccess: (data) => {
      newRequestDrawerStore.updateRequest(data)
      invalidate(['requests-table'])
    },
  })

  return (
    <Stack spacing={'16px'} pb={'16px'}>
      {/* @ts-ignore */}
      <CustomAccordion defaultOpenState summary={'Id оборудования'}>
        <Box mt={'16px'}>
          <FormInput
            control={control}
            fullWidth
            name='equipmentId'
            label={'Id оборудования'}
            placeholder=''
            inputProps={{
              maxLength: 14,
            }}
          />
        </Box>
      </CustomAccordion>
      <Button
        variant='contained'
        onClick={() => mutateAsync()}
        loading={isPending}
        disabled={!isValid}
        sx={{ margin: '0 16px!important ' }}
      >
        Начать установку
      </Button>
    </Stack>
  )
}

export default observer(StartInstallationAcc)
